/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font, spacing, breakpoints } from '@chegg-ui/theme';
import styled from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        lineHeight: theme.font.lineHeight.sm,
        color: colors.grey800,
        activeColor: colors.grey900,
        hoverFontColor: colors.grey900,
        hoverBgColor: colors.grey100,
        ribbonColor: theme.colors.primary.dark,
        ribbonHeight: '4px',
        showRibbonOnHover: false,
        borderColor: theme.colors.border.medium500,
        borderWidth: "".concat(1 / 16, "rem"),
        borderLeftWidth: "0px",
        fontWeight: theme.font.weight.medium,
        hoverSelectedFontWeight: theme.font.weight.bold,
        sm: {
          fontSize: theme.font.size.xxs
        },
        md: {
          fontSize: theme.font.size.xs
        },
        lg: {
          fontSize: theme.font.size.sm
        },
        horizontal: {
          spaceBetweenTabs: theme.spacing.md,
          tabHeaderRadius: "".concat(theme.radius.sm, " ").concat(theme.radius.sm, " 0px 0px"),
          overflowX: 'auto',
          sm: {
            tabPadding: "3px ".concat(theme.spacing.xs, " 5px ").concat(theme.spacing.xs)
          },
          md: {
            tabPadding: "4px ".concat(theme.spacing.md, " 6px ").concat(theme.spacing.md)
          },
          lg: {
            tabPadding: "5px ".concat(theme.spacing.lg, " 6px ").concat(theme.spacing.lg)
          },
          boxShadow: 'initial'
        },
        vertical: {
          spaceBetweenTabs: theme.spacing.md,
          ribbonRadius: "".concat(theme.radius.sm, " 0 0 ").concat(theme.radius.sm),
          tabHeaderRadius: theme.radius.sm,
          boxShadow: '0px 1px 3px 1px rgba(13, 13, 15, 0.15), 0px 1px 2px rgba(13, 13, 15, 0.3)',
          overflowX: 'initial',
          sm: {
            tabPadding: "9.75px ".concat(theme.spacing.sm, " 6.25px ").concat(theme.spacing.md),
            height: theme.spacing.xl
          },
          md: {
            tabPadding: "".concat(theme.spacing.sm, " ").concat(theme.spacing.sm, " 10px ").concat(theme.spacing.md),
            height: theme.spacing.xl2
          },
          lg: {
            tabPadding: "14.5px ".concat(theme.spacing.sm, " 12.5px ").concat(theme.spacing.md),
            height: theme.spacing.xl3
          }
        }
      };
    },
    fanta: {
      ribbonColor: colors.orange400,
      lineHeight: font.lineHeight.md,
      color: colors.grey900,
      showRibbonOnHover: true,
      borderColor: colors.grey,
      borderWidth: "".concat(2 / 16, "rem"),
      borderLeftWidth: "".concat(2 / 16, "rem"),
      fontWeight: font.weight.bold,
      hoverSelectedFontWeight: font.weight.bold,
      hoverBgColor: colors.white,
      sm: {
        fontSize: font.size.px16
      },
      lg: {
        fontSize: font.size.px24,
        ribbonHeight: '8px'
      },
      horizontal: {
        spaceBetweenTabs: spacing.px24,
        overflowX: 'auto',
        sm: {
          tabPadding: "0 ".concat(spacing.px4, " ").concat(spacing.px8, " ").concat(spacing.px4)
        },
        md: {
          tabPadding: "0 ".concat(spacing.px4, " ").concat(spacing.px8, " ").concat(spacing.px4)
        },
        lg: {
          tabPadding: "0 ".concat(spacing.px4, " ").concat(spacing.px12, " ").concat(spacing.px4)
        },
        tabHeaderRadius: '0',
        boxShadow: 'initial'
      },
      vertical: {
        boxShadow: 'initial',
        spaceBetweenTabs: spacing.px16,
        ribbonRadius: 0,
        overflowX: 'auto',
        sm: {
          tabPadding: "0 0 0 ".concat(spacing.px16),
          height: 'auto'
        },
        md: {
          tabPadding: "0 0 0 ".concat(spacing.px16),
          height: 'auto'
        },
        lg: {
          tabPadding: "0 0 0 ".concat(spacing.px24),
          height: 'auto'
        },
        tabHeaderRadius: '0'
      }
    },
    prop: themeProp
  };
};
export var TabsContainer = styled.div.withConfig({
  componentId: "sc-12j2rmq-0"
})(["display:flex;flex-direction:", ";"], function (_ref) {
  var orientation = _ref.orientation;
  return orientation === 'vertical' ? 'row' : 'column';
});
export var TabUl = styled.ul.withConfig({
  componentId: "sc-12j2rmq-1"
})(["padding:0;margin:0;display:flex;list-style:none;height:100%;overflow-x:", ";scrollbar-width:none;-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar{display:none;}", ""], function (_ref2) {
  var orientation = _ref2.orientation,
      customTheme = _ref2.customTheme;
  return customTheme[orientation].overflowX;
}, function (_ref3) {
  var orientation = _ref3.orientation,
      customTheme = _ref3.customTheme,
      size = _ref3.size;
  return orientation === 'vertical' ? "\n    flex-direction: column;\n    border-left: ".concat(customTheme.borderLeftWidth, " solid ").concat(customTheme.borderColor, ";\n\n    & > li {\n      margin-bottom: ").concat(customTheme.vertical && (customTheme.vertical[size].spaceBetweenTabs || customTheme.vertical.spaceBetweenTabs), ";\n  \n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n    ") : "\n    flex-direction: row;\n    border-bottom: ".concat(customTheme.borderWidth, " solid ").concat(customTheme.borderColor, ";\n\n    & > li {\n      margin-right: ").concat(customTheme.horizontal && (customTheme.horizontal[size].spaceBetweenTabs || customTheme.horizontal.spaceBetweenTabs), ";\n  \n      @media (max-width: ").concat(breakpoints.sm.max, ") {\n        margin-right: ").concat(spacing.px16, ";\n      }\n  \n      &:last-child {\n        margin-right: 0;\n        padding-right: 1rem;\n      }\n    }\n    ");
});
export var TabHeaderContainer = styled.div.withConfig({
  componentId: "sc-12j2rmq-2"
})(["position:relative;"]);
export var TabHeader = styled.a.withConfig({
  componentId: "sc-12j2rmq-3"
})(["font-family:", ";font-weight:", ";display:block;text-decoration:none;box-sizing:border-box;position:relative;overflow:hidden;white-space:nowrap;letter-spacing:0.25px;", " @media (max-width:", "){font-size:", ";}@media (max-width:", "){font-size:", ";}"], font.family["default"], function (_ref4) {
  var customTheme = _ref4.customTheme,
      ariaSelected = _ref4['aria-selected'];
  return ariaSelected ? customTheme.hoverSelectedFontWeight : customTheme.fontWeight;
}, function (_ref5) {
  var orientation = _ref5.orientation,
      size = _ref5.size,
      ariaSelected = _ref5['aria-selected'],
      customTheme = _ref5.customTheme;
  return "\n    color: ".concat(ariaSelected ? customTheme.activeColor : customTheme.color, ";\n    line-height: ").concat(customTheme.lineHeight, ";\n    font-size: ").concat(customTheme[size] && customTheme[size].fontSize, ";\n    /** ToDo - Optional chaining throwing test coverage error */\n    padding: ").concat(customTheme[orientation] && customTheme[orientation][size].tabPadding, ";\n    border-radius: ").concat(customTheme[orientation].tabHeaderRadius, ";\n    &:hover{\n      color: ").concat(customTheme.hoverFontColor, ";\n      background-color: ").concat(customTheme.hoverBgColor, ";\n      letter-spacing: ").concat(ariaSelected ? '0.25px' : '0.2px', ";\n    }\n    &::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      background-color: ").concat(customTheme.ribbonColor, ";\n      border-radius: ").concat(customTheme[orientation].tabHeaderRadius, ";\n      transition: transform 0.3s;\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n      \n      @media (max-width: ").concat(breakpoints.sm.max, ") {\n        height: 0.25rem;\n      }\n    }\n\n    ").concat(orientation === 'vertical' ? "\n        @media (max-width: ".concat(breakpoints.sm.max, ") {\n          padding: ").concat(spacing.px4, " ").concat(9 / 16, "rem;\n        }\n        box-shadow: ").concat(ariaSelected && customTheme[orientation].boxShadow, ";\n        height: ").concat(customTheme[orientation][size] && customTheme[orientation][size].height, ";\n        &::after {\n          top: 0;\n          width: ").concat(customTheme[size] && customTheme[size].ribbonHeight || customTheme.ribbonHeight, ";\n          height: 100%;\n          transform: translateX(-100%);\n          border-radius: ").concat(customTheme[orientation] && customTheme[orientation].ribbonRadius, ";\n          ").concat(ariaSelected ? 'transform: translateX(0);' : '', "\n        }\n        &:hover::after {\n          transform: ").concat(ariaSelected ? 'translateX(0)' : customTheme.showRibbonOnHover ? 'translateX(-50%)' : 'translateX(-100%)', ";\n        }\n      ") : "\n        @media (max-width: ".concat(breakpoints.sm.max, ") {\n          padding: 0 ").concat(spacing.px4, " ").concat(6 / 16, "rem;\n        }\n\n        &::after {\n          bottom: 0;\n          width: 100%;\n          height: ").concat(customTheme[size] && customTheme[size].ribbonHeight || customTheme.ribbonHeight, ";\n          transform: translateY(100%);\n          ").concat(ariaSelected ? 'transform: translateY(0);' : '', "\n        }\n        &:hover::after {\n          transform: ").concat(ariaSelected ? 'translateY(0)' : customTheme.showRibbonOnHover ? 'translateY(50%)' : 'translateY(100%)', ";\n        }\n      "), "\n  ");
}, breakpoints.md.max, font.size.px16, breakpoints.sm.max, font.size.px12);
export var TabAffordance = styled.div.withConfig({
  componentId: "sc-12j2rmq-4"
})(["width:2rem;z-index:1;top:0;position:absolute;pointer-events:none;height:calc(100% - 1rem);@media (max-width:", "){height:calc(100% - 0.6rem);}", ""], breakpoints.sm.max, function (_ref6) {
  var position = _ref6.position;
  return "\n    background: linear-gradient(\n      to ".concat(position, ",\n      rgba(255, 255, 255, 0),\n      rgba(255, 255, 255, 1)\n    );\n    ").concat(position, ": 0;\n  ");
});
export var FilterTabUl = styled.ul.withConfig({
  componentId: "sc-12j2rmq-5"
})(["padding:0;margin:0;display:flex;list-style:none;font-size:", ";color:", ";& > li{&:first-of-type{a{margin-left:0;}}&:last-of-type{a{margin-right:0;}}}li + li{border-left:", ";}"], font.size.px16, colors.dark, function (_ref7) {
  var customTheme = _ref7.customTheme;
  return customTheme.borderLeft;
});
export var FilterTabHeader = styled.a.withConfig({
  componentId: "sc-12j2rmq-6"
})(["display:flex;font-family:", ";font-weight:", ";color:", ";line-height:", ";margin:0 ", "rem;&:hover{text-decoration:underline;cursor:pointer;}&[aria-selected]{color:", ";font-weight:", ";&:hover{text-decoration:none;}}"], font.family["default"], function (_ref8) {
  var customTheme = _ref8.customTheme;
  return customTheme.defaultFontWeight;
}, function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.defaultFontColor;
}, function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.lineHeight;
}, 15 / 16, function (_ref11) {
  var customTheme = _ref11.customTheme;
  return customTheme.selectedFontColor;
}, function (_ref12) {
  var customTheme = _ref12.customTheme;
  return customTheme.selectedFontWeight;
});
export var getFiltertabThemeConfig = function getFiltertabThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        borderLeft: "1px solid ".concat(theme.colors.border.medium500),
        defaultFontWeight: theme.font.weight.medium,
        selectedFontWeight: theme.font.weight.bold,
        defaultFontColor: theme.colors.secondary.dark,
        selectedFontColor: theme.colors.border.dark900,
        lineHeight: theme.font.lineHeight.sm
      };
    },
    fanta: {
      borderLeft: "2px solid ".concat(colors.dark),
      defaultFontWeight: font.weight.bold,
      selectedFontWeight: font.weight.bold,
      defaultFontColor: colors.link,
      selectedFontColor: colors.dark,
      lineHeight: "".concat(20 / 16, "rem")
    },
    prop: themeProp
  };
};